(() => {
  'use strict';
  const rows = [
    ['Board / darts', 'board', '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/>'],
    ['Games', 'games', '<path d="M6 6h12l3 11c1 4-3 4-6 0H9c-3 4-7 4-6 0Z"/><path d="M6 11h6m-3-3v6m7-3h.01m2 3h.01"/>'],
    ['Players', 'players', '<circle cx="9" cy="7" r="3"/><path d="M3 21v-3a6 6 0 0 1 12 0v3m1-17a3 3 0 0 1 0 6m2 5a5 5 0 0 1 3 5"/>'],
    ['Scoring', 'scoring', '<rect x="3" y="3" width="18" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/>'],
    ['AI levels', 'ai', '<rect x="4" y="7" width="16" height="13" rx="2"/><path d="M12 3v4M2 12v4m20-4v4M8 12h.01M16 12h.01M8 16h8"/>'],
    ['Player lights', 'lights', '<path d="M9 18h6m-6 3h6M8 14a7 7 0 1 1 8 0l-1 4H9Z"/>'],
    ['Voice', 'voice', '<path d="m11 4-6 5H2v6h3l6 5Zm4 4a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/>'],
    ['Dimensions', 'size', '<path d="m3 8 5-5 13 13-5 5Zm4-1 2 2m1 1 2 2m1 1 2 2m1 1 2 2"/>'],
    ['Width, open', 'width', '<path d="M3 12h18M7 8l-4 4 4 4m10-8 4 4-4 4"/>'],
    ['Weight', 'weight', '<circle cx="12" cy="5" r="3"/><path d="M5 9h14l3 12H2Z"/>']
  ];
  const modelIcon = '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 8h18M9 8v13"/>';
  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function labelCell(label, icon, scope) {
    const cell = el('th'); cell.scope = scope;
    const labelNode = el('span', 'yiri-compare__param');
    labelNode.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true">' + icon + '</svg>';
    labelNode.append(el('span', '', label)); cell.append(labelNode);
    if (label === 'Dimensions') cell.append(el('small', 'yiri-compare__unit', 'W × H × D'));
    return cell;
  }
  function init(root) {
    if (root.dataset.ready) return;
    const json = root.querySelector('[data-yiri-compare-data]');
    if (!json) return;
    let data;
    try { data = JSON.parse(json.textContent); } catch (_) { return; }
    root.dataset.ready = 'true';
    const current = data.current;
    const cache = new Map([current, ...data.defaults].map(p => [p.id, p]));
    const scroll = root.querySelector('.yiri-compare__scroll');
    const hint = root.querySelector('.yiri-compare__hint');
    const status = root.querySelector('.yiri-compare__status');
    let key, revision = 0, columnCount = 3;
    // Sticky cells must remain opaque on the section's configured background.
    let ancestor = root;
    while (ancestor) {
      const color = getComputedStyle(ancestor).backgroundColor;
      if (color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)') {root.style.setProperty('--yc-surface', color);break;}
      ancestor = ancestor.parentElement;
    }
    function sizeHint() {
      if (!scroll.clientWidth) return;
      const mobile = window.matchMedia('(max-width:767px)').matches;
      if (!mobile) {
        root.style.removeProperty('--yc-label');
        const label = parseFloat(getComputedStyle(root).getPropertyValue('--yc-label'));
        root.style.setProperty('--yc-product', Math.max(250, (scroll.clientWidth - label) / Math.min(columnCount, 3)) + 'px');
      } else {
        const label = Math.max(76, Math.round(scroll.clientWidth * .28));
        root.style.setProperty('--yc-label', label + 'px');
        root.style.setProperty('--yc-product', ((scroll.clientWidth - label) / 2) + 'px');
      }
      hint.hidden = scroll.scrollWidth <= scroll.clientWidth + 1;
    }
    function render(products) {
      const previousScroll = scroll.scrollLeft;
      const header = el('tr'); header.append(labelCell('Model', modelIcon, 'col'));
      products.forEach((p, index) => {
        const cell = el('th'); cell.scope = 'col';cell.dataset.productId = p.id;
        cell.append(el('span', 'yiri-compare__viewing', index === 0 ? "You're viewing" : ''));
        if (p.image) {const img = el('img', 'yiri-compare__image');img.src = p.image;img.alt = p.name + ' open cabinet';img.width = 480;img.height = 300;img.loading = 'lazy';cell.append(img);}
        const name = el(index ? 'a' : 'span', 'yiri-compare__name', p.name);
        if (index) name.href = p.url;
        cell.append(name, el('div', 'yiri-compare__price', p.price));header.append(cell);
      });
      const body = document.createDocumentFragment();
      rows.forEach(([label, field, icon], i) => {
        const tr = el('tr');tr.append(labelCell(label, icon, 'row'));
        products.forEach(p => {
          const cell = el('td');
          const value = p.overrides?.[field] ?? p.values?.[i] ?? '—';
          String(value).split(';').forEach((part, index) => cell.append(el(index ? 'small' : 'span', index ? 'yiri-compare__unit' : '', part)));
          tr.append(cell);
        });body.append(tr);
      });
      columnCount = products.length;
      root.style.setProperty('--yc-count', products.length);
      root.querySelector('thead').replaceChildren(header);root.querySelector('tbody').replaceChildren(body);
      scroll.scrollLeft = previousScroll;sizeHint();
    }
    function selected() {
      try {return [...new Set((localStorage.getItem('t4s_cp') || '').split(',').map(x => x.trim().replace(/^id:/, '')).filter(x => /^\d+$/.test(x)))].slice(0, 6).filter(id => id !== current.id);} catch (_) {return [];}
    }
    async function sync() {
      const ids = selected(), next = ids.join(',');
      if (key === next) return;
      key = next;const token = ++revision;
      status.textContent = '';
      root.removeAttribute('aria-busy');
      if (!ids.length) {render([current, ...data.defaults]);return;}
      // Remove deselected columns immediately; fetch only missing products.
      render([current, ...ids.map(id => cache.get(id)).filter(Boolean)]);
      const missing = ids.filter(id => !cache.has(id));
      if (missing.length) {
        root.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(root.dataset.searchUrl, location.origin);
          url.search = new URLSearchParams({view:'yiri-compare',type:'product',q:missing.map(id => 'id:' + id).join(' OR '),'options[unavailable_products]':'last'}).toString();
          const response = await fetch(url, {credentials:'same-origin'});
          if (!response.ok) throw new Error('Comparison request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = JSON.parse(doc.querySelector('[data-yiri-compare-results]').textContent);
          results.forEach(p => cache.set(p.id, p));
        } catch (_) {
          if (token === revision) {key = undefined;status.textContent = 'Some models could not load. Reopen Compare to retry.';}
        } finally {if (token === revision) root.removeAttribute('aria-busy');}
      }
      if (token !== revision) return;
      render([current, ...ids.map(id => cache.get(id)).filter(Boolean)]);
      if (ids.some(id => !cache.has(id)) && !status.textContent) status.textContent = 'Some selected models are unavailable in this market.';
    }
    render([current, ...data.defaults]);sync();
    // The theme writes t4s_cp synchronously in its delegated click handlers.
    document.addEventListener('click', e => {
      if (e.target.closest('[data-action-compare],[data-remove-compare],[data-clear-compare],[data-t4s-tab-item]')) setTimeout(sync, 0);
    }, true);
    window.addEventListener('storage', e => {if (e.key === 't4s_cp' || e.key === null) sync();});
    window.addEventListener('focus', sync);
    document.addEventListener('visibilitychange', () => {if (!document.hidden) sync();});
    new ResizeObserver(sizeHint).observe(scroll);
  }
  document.querySelectorAll('[data-yiri-compare]').forEach(init);
  if (!window.yiriCompareSectionListener) {
    window.yiriCompareSectionListener = true;
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-yiri-compare]').forEach(init));
  }
})();
